import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
import BaseField from "./BaseField";

/** Liaison de graphique */
export default class GraphEdge extends BaseField {
	/** 
	 * Constructeur avec paramètres
	 * @param from		Id du noeud entrant
	 * @param fromPort	Port entrant
	 * @param to		Id du noeud sortant
	 * @param toPort	Port sortant
	 */
	public constructor() 
	public constructor(from: string, fromPort: string, to: string, toPort: string)
	public constructor(from: string = "", fromPort: string = "", to: string = "", toPort: string = "") {
	 	super(FieldTypeEnum.Node);
		
		this.From = from;
		this.FromPort = fromPort;
		this.To = to;
		this.ToPort = toPort;
	}

	/** Id du noeud entrant */
	public From: string;

	/** Port entrant */
	public FromPort: string;

	/** Id du noeud sortant */
	public To: string;

	/** Port sortant */
	public ToPort: string;
}